import { memo, CSSProperties } from 'react'
import { decodeText } from '@aytm/app/stats/lib/util/helpers'

import { CompareItemsTableSplitHeaderCell as TCompareItemsTableSplitHeaderCell } from '../../types'

import useModes from '../../states/useModes'
import useComponentLayout from '../../states/useComponentLayout'
import useSigtest from '../../states/useSigtest'

import style from './SplitHeaderCell.module.scss'

export default memo(
  CompareItemsTableSplitHeaderCell,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell === nextProps.cell
)
export function CompareItemsTableSplitHeaderCell({
  className,
  width,
  cell
}: {
  className: string
  width: number
  cell: TCompareItemsTableSplitHeaderCell
}) {
  const modes = useModes()
  const componentLayout = useComponentLayout()
  const sigtest = useSigtest()

  const { visualContentWidth = 0, dataVisualWidth = 0, attributeColFullWidth = 0 } = componentLayout.measures

  const labelStyle =
    0 <= dataVisualWidth && width > dataVisualWidth
      ? {
          position: 'sticky' as CSSProperties['position'],
          left: attributeColFullWidth + 6,
          width: 'max-content' as CSSProperties['width'],
          maxWidth: Math.min(width, dataVisualWidth - 12)
        }
      : null
  const swapButtonStyle: CSSProperties = cell.splitSwap
    ? {
        left: visualContentWidth - 26
      }
    : null

  return (
    <div
      className={`${className || ''} ${style.CompareItemsTableSplitHeaderCell} ${
        false !== cell.lastInGroup ? style['CompareItemsTableSplitHeaderCell--lastInGroup'] : ''
      } ${cell.subGroup ? style['CompareItemsTableSplitHeaderCell--subGroup'] : ''}`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
      data-compare-items="split-header-cell"
      data-compare-items-header-col={cell.col}
      data-compare-items-split-value-index={cell.valueIndex}
    >
      <div className={style.CompareItemsTableSplitHeaderCell__text} style={labelStyle}>
        {decodeText(cell.text)}
      </div>
      {'splitValue' === sigtest?.type && sigtest?.letters.has(cell.valueIndex) ? (
        <div
          className={`${style.CompareItemsTableSplitHeaderCell__sigtest} ${
            cell.splitSwap ? style['CompareItemsTableSplitHeaderCell__sigtest--splitSwap'] : ''
          }`}
        >
          {sigtest.letters.get(cell.valueIndex)}
        </div>
      ) : null}
      {cell.splitSwap && modes.useSplitBy ? (
        <i
          className={`icon-aytmfd-swap ${style.CompareItemsTableSplitHeaderCell__swap_button}`}
          title="Swap items and split values"
          style={swapButtonStyle}
          onClick={() =>
            void modes.onChangeSplitBy({
              ...modes.splitBy,
              group: 'items' === modes.splitBy.group ? 'values' : 'items'
            })
          }
        />
      ) : null}
    </div>
  )
}
